import { Chip, Grid } from '@material-ui/core';
import { LoanCriteria } from '@nemuru-eng/js-api-client';

import { numberOfCoborrowers } from '@/components/modules/LoanListByProduct/utils/LoanDataGridFields/loanHasCoborrowers';

import { Font } from '../../../../../shared/components/Font';
import { Text } from '../../../../../shared/components/Text';

export const borrowerNameFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.38,
    field: 'borrowerName',
    sortable: false,
    align: 'left',
    headerName: <Text tId={'CLIENT'} />,
    renderCell: (rowData: { row: LoanCriteria }) => {
      const numberOfCoBorrowers = numberOfCoborrowers(rowData.row);

      return (
        <>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              whiteSpace: 'break-spaces',
              lineHeight: '1.43',
              width: '100%',
            }}
          >
            <Grid container alignItems={'center'}>
              <Grid item xs={numberOfCoBorrowers ? 10 : 12}>
                <div className={'line-clamp-3'} style={{ marginRight: numberOfCoBorrowers > 0 ? '4px' : '0px' }}>
                  {rowData.row.borrowerInvitation?.fullName
                    ? `${rowData.row.borrowerInvitation.fullName.firstName} ${rowData.row.borrowerInvitation.fullName.lastName}`
                    : '-'}
                </div>
              </Grid>
              {numberOfCoBorrowers > 0 && (
                <Grid item xs={2}>
                  <Chip
                    style={{ fontSize: 0 }}
                    label={
                      <Font variant={'caption'} color="textSecondary">
                        <strong>{`+${numberOfCoBorrowers}`}</strong>
                      </Font>
                    }
                    variant={'outlined'}
                    size={'small'}
                  />
                </Grid>
              )}
            </Grid>
          </div>
        </>
      );
    },
  };
};
